import { SeverityPill } from "../generic/components/severity-pill";

import type { SeverityPillColor, SeverityPillVariant } from "../generic/components/severity-pill";
import type { ReviewStatus } from "../moment/server/supabase-moment-review-service";
import type { MomentStatus } from "./types";
import type { ReactNode } from "react";

export const reviewStatusColours: Partial<
  Record<ReviewStatus, { color: SeverityPillColor; label: string }>
> = {
  IN_REVIEW: { color: "info", label: "in review" },
  COMMENTED: { color: "warning", label: "commented" },
  APPROVED: { color: "success", label: "approved" },
  CHANGES_REQUESTED: { color: "error", label: "changes requested" },
  PUBLISHED: { color: "primary", label: "published" },
};

export const reviewStatusToPill = (
  reviewStatus: ReviewStatus,
  variant: SeverityPillVariant = "solid",
): ReactNode => {
  const pill = reviewStatusColours[reviewStatus];

  return pill ? (
    <SeverityPill color={pill.color} variant={variant} data-testid={`${reviewStatus}-pill`}>
      {pill.label}
    </SeverityPill>
  ) : null;
};

export const statusToPill = (
  status: MomentStatus,
  valueMap: { [_: string]: SeverityPillColor } = {
    draft: "warning",
    paused: "disabled",
    active: "error",
    finished: "info",
    archived: "disabled",
  },
  variant: SeverityPillVariant = "solid",
): ReactNode => (
  <SeverityPill color={valueMap[status]!} variant={variant} data-testid={`${status}-pill`}>
    {status}
  </SeverityPill>
);
